import React from 'react';
import {useSelector} from 'react-redux';

import Draggable, { DraggablePlace } from '@common/react/components/UI/Draggable';
import '@common/react/scss/components/videoChatModal.scss';
import VideoChat from '@common/react/components/UI/VideoChat/VideoChat';

interface VideoChatModal {
	skeletonImage?: string;
	defaultPlace?: DraggablePlace;
	dragContainerPadding?: number;
	avatarComponent?: (avatar?: string, userName?: string) => React.ReactNode;
}

const defaultAvatarComponent = (avatar) => {
	return <img src={avatar} alt="Avatar" />;
};

const VideoChatModal: React.FC<VideoChatModal> = (props) => {
	const {skeletonImage, defaultPlace = 'leftBottom', dragContainerPadding = 30, avatarComponent = defaultAvatarComponent} = props;
	const videoChatState = useSelector((state: any) => state.videoChat);

	const [isMinimized, setIsMinimized] = React.useState<boolean>(false);
	const [isFullscreen, setFullscreen] = React.useState<boolean>(false);

	const handleMinimize: React.MouseEventHandler = (e) => {
		e.preventDefault();

		setIsMinimized(true);
	};

	const handleMaximize: React.MouseEventHandler = (e) => {
		e.preventDefault();

		setIsMinimized(false);
	};

	return (
		<Draggable
			className={`video-chat-modal video-chat-modal_${videoChatState.visibility ? 'visible' : 'hidden'}`}
			isDraggable={true}
			isInOrigin={isFullscreen}
			ignoreElements={['btn-video-chat-close', 'btn']}
			defaultPosition={defaultPlace}
			padding={dragContainerPadding}
		>
			<div className="video-chat-modal__inner">
				<div className="video-chat-header">
					<div className="video-chat-header__left">
						{avatarComponent(videoChatState.avatar || skeletonImage, videoChatState.roomName)}
						<span>{videoChatState.roomName}</span>
					</div>

					{/*<div className="video-chat-header__right">
						{
							!isMinimized ?
								<Button
									shape="circle"
									type="text"
									className="btn-video-chat-close"
									onClick={handleMinimize}>
									<i className="fa fa-window-minimize"/>
								</Button> :
								<Button
									shape="circle"
									type="text"
									className="btn-video-chat-close"
									onClick={handleMaximize}>
									<i className="fa fa-window-maximize"/>
								</Button>
						}
					</div>*/}
				</div>

				{videoChatState.visibility && <div className="video-chat-main">
					<VideoChat
						isMinimized={isMinimized}
						isFullscreen={isFullscreen}
						setFullscreen={setFullscreen}
					/>
				</div>}
			</div>
		</Draggable>
	);
};

export default VideoChatModal;
